import 'css-chunksrc/client/common/projectsSelection/zones/zone/styles.scss';export default {
  "header": "_header_1nb3v_1",
  "icon": "_icon_1nb3v_10",
  "name": "_name_1nb3v_17",
  "projects": "_projects_1nb3v_24"
};